module.exports = __webpack_public_path__ + "fonts/trust_sans_bold-webfont.6967df54.woff";